import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 *
 * Fixes the "page opens halfway down" bug on mobile by resetting the scroll
 * position every time the URL pathname changes. React Router intentionally
 * preserves scroll position, which is great for back-nav on desktop but feels
 * broken on phones where you swipe between pages and land mid-content.
 *
 * Mount ONCE inside <BrowserRouter>. No JSX, no props.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use "instant" so we don't animate — respects reduce-motion and feels tight.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
